import { useEffect } from "react";
import { useImmer } from "use-immer";

import { GetThemesResponseBodyType } from "@intelligems/ig-types/functions/shops/get-themes";
import { useDispatch } from "@src/store";
import { initThemes } from "@src/store/slices/themes";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { useGetOrg } from "../organizations/get-organization";
import { organizationThemesKey } from "../queryKeys";

const getThemes = async () => {
  const resp = await api.get<GetThemesResponseBodyType>(
    "/v2/organizations/themes"
  );
  return resp.data;
};

export const useGetThemes = () => {
  const dispatch = useDispatch();
  const org = useGetOrg();
  const response = useQuery<GetThemesResponseBodyType, Error>({
    queryKey: organizationThemesKey.one(org.data.org.id),
    queryFn: async () => getThemes(),
  });
  useEffect(() => {
    if (response.data?.themes) {
      dispatch(initThemes(response.data.themes));
    }
  }, [response.data?.themes]);

  return response;
};

export const useLiveOrgTheme = () => {
  const [id, setId] = useImmer<string | undefined>(undefined);

  const themes = useGetThemes();

  useEffect(() => {
    setId(
      (themes.data?.themes || [])
        .find((theme) => theme.role === "main")
        ?.id?.toString() || undefined
    );
  }, [themes.data?.themes]);

  return id;
};
